import styled, { css } from 'styled-components';

import { device, typography } from '@/styles/helpers';

export interface ScSectionTitleProps {
  center?: boolean;
  multiRow?: boolean;
}

export const ScSectionTitle = styled.h2<ScSectionTitleProps>`
  text-transform: uppercase;
  margin-bottom: 24px;
  ${typography['headline2']}
  display: flex;
  align-items: center;
  ${({ center }) =>
    center &&
    css`
      justify-content: center;
    `}

  & .title {
    display: flex;
    align-items: center;
  }

  & .after-title {
    margin-left: 8px;
    display: flex;
    align-items: center;
  }

  ${({ multiRow }) =>
    multiRow &&
    css`
      flex-direction: column;
      align-items: flex-start;
      row-gap: 8px;
      margin-bottom: 16px;

      & > .description {
        font-size: 14px;
        line-height: 14px;
      }
    `}

  @media (${device.mobile}) {
    ${typography['headline2mobile']}
  }
`;
